import { render, staticRenderFns } from "./deviceRules.vue?vue&type=template&id=2e97611d&"
import script from "./deviceRules.vue?vue&type=script&lang=js&"
export * from "./deviceRules.vue?vue&type=script&lang=js&"
import style0 from "./deviceRules.vue?vue&type=style&index=0&id=2e97611d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports